const R = require('ramda');

const spreadProp = R.converge(R.merge, [R.dissoc, R.propOr({})]);

module.exports = {spreadProp};
